import { createLogger } from '@genesislcap/foundation-logger';
/**
 * Logger for the grid-pro package
 * @public
 */
export const logger = createLogger('grid-pro');
